module.exports = __webpack_public_path__ + "static/img/last-new-folder.342a2033.png";